module.exports = __webpack_public_path__ + "static/media/dekton.4d9e1452.svg";